import useApi from '../../../services/useApi'
import {TicketDetailsContext} from '../context'
import {useContext} from 'react'

const useGetAttachmentListing = () => {
  const Api = useApi()
  const {ticketId} = useContext(TicketDetailsContext)

  const {
    data: response,
    isFetching,
    refetch,
  } = Api.useGetQuery(`/agile/projects/cards/${ticketId}/attachments`, {
    queryId: `attachment-listing`,
    isCaching: false,
  })

  return {
    attachmentListing: response?.data || [],
    isLoading: isFetching,
    refetch,
  }
}

export default useGetAttachmentListing
